import { VueQueryPlugin } from '@tanstack/vue-query'
import { MotionPlugin } from '@vueuse/motion'
import axios from 'axios'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import VueGridLayout from 'vue-grid-layout'

import App from './App.vue'
import router from './router'

// Import global styles
import './assets/main.css'
import './lib/echo'

// Wait for Material Symbols font to load before showing icons
// This prevents the flash of unstyled text (FOUT) for icons
if (document.fonts) {
  // Check if Material Symbols Outlined font is loaded
  document.fonts.ready.then(() => {
    // Verify the specific font is loaded
    const isMaterialSymbolsLoaded = document.fonts.check('24px "Material Symbols Outlined"')
    if (isMaterialSymbolsLoaded) {
      document.documentElement.classList.add('fonts-loaded')
    } else {
      // Wait a bit longer and check again
      setTimeout(() => {
        const isLoaded = document.fonts.check('24px "Material Symbols Outlined"')
        if (isLoaded) {
          document.documentElement.classList.add('fonts-loaded')
        } else {
          // Give up and show anyway after 500ms
          setTimeout(() => {
            document.documentElement.classList.add('fonts-loaded')
          }, 500)
        }
      }, 100)
    }
  })
} else {
  // Fallback for browsers without Font Loading API
  setTimeout(() => {
    document.documentElement.classList.add('fonts-loaded')
  }, 300)
}

const app = createApp(App)

if (import.meta.env.PROD && import.meta.env.VITE_BEACON_DSN && window.Beacon) {
  window.Beacon.init({ dsn: import.meta.env.VITE_BEACON_DSN as string, analytics: true })
  window.Beacon.install(app)
}

app.use(createPinia())
app.use(router)
app.use(VueGridLayout)
app.use(MotionPlugin)

app.mount('#app')
